/************************* linked products - Title hover  *************************/

const linkedProductCurrentColorName = document.querySelector('.gtc\\:linked-products [data-linked-product-current-color-name]');
const linkedProductsColorName = document.querySelectorAll('.gtc\\:linked-products [data-linked-product-color-name]');

if (linkedProductCurrentColorName && linkedProductsColorName.length > 1) {
    const currentColorNameText = linkedProductCurrentColorName.hasAttribute('data-linked-product-current-color-name') ? linkedProductCurrentColorName.getAttribute('data-linked-product-current-color-name') : ''

    const changeColorName = (text) => {
        linkedProductCurrentColorName.innerText = text
    }

    linkedProductsColorName.forEach(colorName => {

        const colorNameText = colorName.hasAttribute('data-linked-product-color-name') ? colorName.getAttribute('data-linked-product-color-name') : ''

        colorName.addEventListener('mouseover', () => {
            changeColorName(colorNameText)
        });
        colorName.addEventListener('mouseout', () => {
            changeColorName(currentColorNameText)
        });
    });
}

